// extracted by mini-css-extract-plugin
module.exports = {"thecomp":"EU6_thecomp__tb0I3"};